import EasterEggGame from '../client/EasterEggGame.ui';

export function FeatureEasterEggGame() {
	return <EasterEggGame />;
}

export default FeatureEasterEggGame;
